export enum LobbyFilterSeat {
    Any = -1, // local only
    Two = 2,
    Six = 6,
    Nine = 9,
    Ten = 10
}

